export function getOrderSourceLabel(source: any): string {
    if (source === undefined || source === null || String(source).trim() === '') {
        return '-';
    }

    const normalizedSource = String(source).trim().toLowerCase();
    const labels: { [source: string]: string } = {
        ios: 'iOS',
        android: 'Android',
        oldios: 'Legacy iOS',
        oldandroid: 'Legacy Android',
        broadcast: 'Dispatch',
        pos: 'POS',
        posandroid: 'POS Android',
        radio: 'Radio',
        driver: 'Street Order',
        airport: 'Airport',
        kiosk: 'Kiosk',
        manual: 'Manual',
        caller: 'Caller',
        unknown: 'Unknown'
    };

    return labels[normalizedSource]
        || normalizedSource.charAt(0).toUpperCase() + normalizedSource.slice(1);
}
